import React, { useContext } from "react"
import LocaleContext from "../../../../../context/LocaleContext"
import translate, { keys } from "../../../../../translation/translator"
import CalculatorsStyle from "./CalculatorsStyle.module.styl"
import BMICalculatorIcon from "../../../../../assets/images/icon - bmi calculator.svg"
import FoodNavigatorImage from "../../../../../assets/images/icon - food navigator 1.svg"
import MetabolicSpeed from "../../../../../assets/images/icon - calorie calculator.svg"
import UnitsImage from "../../../../../assets/images/icon - food navigator 2.svg"
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight } from "@fortawesome/free-solid-svg-icons/faArrowRight"

const CalculatorsInfo = () => {
  const locale = useContext(LocaleContext).locale
  return (
    <div className={CalculatorsStyle.holder}>
      <Link to="/bmi-calculator" className={CalculatorsStyle.calculator_item}>
        <div className={CalculatorsStyle.calculator_image_holder}>
          <img src={BMICalculatorIcon} alt="body-mass-index" />
        </div>
        <p className={CalculatorsStyle.title}>
          {translate(keys.INDEX_CALC_INFO_BMI, locale)}
        </p>
        <p className={CalculatorsStyle.info}>
          {translate(keys.INDEX_CALC_INFO_WHATS_BEST_WEIGHT, locale)}
        </p>
        <button className={CalculatorsStyle.button}>
          {translate(keys.INDEX_CALC_INFO_SEE_MORE, locale)}{" "}
          <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </Link>
      <Link
        to="/calorie-calculator"
        className={CalculatorsStyle.calculator_item}
      >
        <div className={CalculatorsStyle.calculator_image_holder}>
          <img src={MetabolicSpeed} alt="body-mass-index" />
        </div>
        <p className={CalculatorsStyle.title}>
          {translate(keys.INDEX_CALC_INFO_CAL_CALC, locale)}
        </p>
        <p className={CalculatorsStyle.info}>
          {translate(keys.INDEX_CALC_INFO_DAILY_CAL_INTAKE, locale)}
        </p>
        <button className={CalculatorsStyle.button}>
          {translate(keys.INDEX_CALC_INFO_SEE_MORE, locale)}{" "}
          <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </Link>
      <Link
        to="/nutrition-calculator"
        className={CalculatorsStyle.calculator_item}
      >
        <div className={CalculatorsStyle.calculator_image_holder}>
          <img src={UnitsImage} alt="body-mass-index" />
        </div>
        <p className={CalculatorsStyle.title}>
          {translate(keys.INDEX_CALC_INFO_FOOD_NAV_I, locale)}
        </p>
        <p className={CalculatorsStyle.info}>
          {translate(keys.INDEX_CALC_INFO_FOOD_U_NEED, locale)}
        </p>
        <button className={CalculatorsStyle.button}>
          {translate(keys.INDEX_CALC_INFO_SEE_MORE, locale)}{" "}
          <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </Link>
      <Link to="/gl-calculator" className={CalculatorsStyle.calculator_item}>
        <div className={CalculatorsStyle.calculator_image_holder}>
          <img src={FoodNavigatorImage} alt="body-mass-index" />
        </div>
        <p className={CalculatorsStyle.title}>
          {translate(keys.INDEX_CALC_INFO_FOOD_NAV_II, locale)}
        </p>
        <p className={CalculatorsStyle.info}>
          {translate(keys.INDEX_CALC_INFO_GLIC_INDEX, locale)}
        </p>
        <button className={CalculatorsStyle.button}>
          {translate(keys.INDEX_CALC_INFO_SEE_MORE, locale)}{" "}
          <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </Link>
    </div>
  )
}

export default CalculatorsInfo
